export const PList = [
  {
    id: 101,
    parkingName: '游客服务中心停车场',
    parkingNumber: 20,
    parkingMargin: 3,
    latitude: 30.809889,
    longitude: 120.813591,
    parkingAddress: '灵湖北路湘家荡环湖景区游客服务中心',
  },
  {
    id: 2,
    parkingName: '鹭栖庭院东北门停车场',
    parkingNumber: 17,
    parkingMargin: 7,
    latitude: 30.804624,
    longitude: 120.808271,
    parkingAddress: '鹭栖庭院东东北门对面停车场',
  },
  {
    id: 3,
    parkingName: '灵湖南路钓鱼所停车场',
    parkingNumber: 15,
    parkingMargin: 8,
    latitude: 30.795377,
    longitude: 120.822871,
    parkingAddress: '灵湖南路钓鱼所对面',
  },
  {
    id: 4,
    parkingName: '精严讲寺东南停车场',
    parkingNumber: 10,
    parkingMargin: 6,
    latitude: 30.800023,
    longitude: 120.82828,
    parkingAddress: '灵光街精严讲寺东南侧约100米',
  },
  {
    id: 5,
    parkingName: '1号地上停车场',
    parkingNumber: 36,
    parkingMargin: 20,
    latitude: 30.803365,
    longitude: 120.819952,
    parkingAddress: '湘家荡-1号地上停车场',
  },
  {
    id: 6,
    parkingName: '2号地上停车场',
    parkingNumber: 31,
    parkingMargin: 19,
    latitude: 30.801835,
    longitude: 120.820027,
    parkingAddress: '湘家荡2号地上停车场',
  },
  {
    id: 107,
    parkingName: '湘湖新天地北停车场',
    parkingNumber: 30,
    parkingMargin: 11,
    latitude: 30.800693,
    longitude: 120.821526,
    parkingAddress: '湘湖新天地1楼北边，物业监控室',
  },
  {
    id: 102,
    parkingName: '月亮沙滩停车场',
    parkingNumber: 80,
    parkingMargin: 20,
    latitude: 30.80904,
    longitude: 120.811284,
    parkingAddress: '浙江省嘉兴市南湖区七星街道320国道边上月亮湾沙滩内',
  },
  {
    id: 9,
    parkingName: '云萝洲停车场',
    parkingNumber: 30,
    parkingMargin: 8,
    latitude: 30.792033,
    longitude: 120.816858,
    parkingAddress: '灵湖南路云萝洲旁',
  },
]
